import type { TSidebarCollapsedSections } from "../types/sidebar-sections";

// NOTE: NSAI-5926 — the sidebar's collapse state comes back from device storage
// as untyped JSON: an older build, a hand-edited entry or a half-written value
// must degrade to "nothing remembered" rather than throw while the sidebar is
// rendering. Unknown-shaped entries are dropped one by one instead of voiding
// the whole record, so one bad key cannot re-open every section the user
// folded away.
export const parseStoredCollapsedSidebarSections = (
  storedValue: string | null,
): TSidebarCollapsedSections => {
  if (!storedValue) {
    return {};
  }

  let parsedValue: unknown;

  try {
    parsedValue = JSON.parse(storedValue);
  } catch {
    return {};
  }

  if (
    typeof parsedValue !== "object" ||
    parsedValue === null ||
    Array.isArray(parsedValue)
  ) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(parsedValue).filter(
      (entry): entry is [string, boolean] =>
        entry[0].length > 0 && typeof entry[1] === "boolean",
    ),
  );
};
